<template>
<div>
    <!--<form method="post">-->
        <h4 class="text-primary font-weight-bolder">Ҷустуҷӯ</h4>
        <hr />
    <div class="col-4">

        <div class="mb-2">
            <label class="form-label" for="name">Ному насаби сардори хоҷагӣ</label>
            <input class="form-control" name="name"  v-model="name"/>

          
        </div>

 
        <Button class="btn btn-primary" @click="find()" > Ҷустуҷӯ</Button>
    </div>

<!--</form>-->

<table class="table table-striped">
    <thead>
        <tr>
            <th>
                #
            </th>
            <th>
                Ному насаби сардори хоҷагӣ
            </th>
            <th>
                Суроға
            </th>
            <th>
                Суратҳисоб
            </th>
            <th>
                Китоб
            </th>
            <th>
                Саҳифа
            </th>
            <th>
                Шумораи аҳолӣ
            </th>
            <th>
                аз он маъюб
            </th>
  
                <th>
                Гурӯҳи хоҷагӣ
            </th>

            <th></th>
        </tr>
    </thead>
    <tbody>
     
        <tr  v-for="h in list" :key="h">
                    <td>
                            {{h.ID}}
                        </td>
                        <td>
                            {{h.Head}}
                        </td>
                        <td>
                            {{h.Address}}
                        </td>
                        <td>
                            {{h.Account}}
                        </td>
                        <td>
                            {{h.Nbook}}
                        </td>
                        <td>
                            {{h.Npage}}
                        </td>
                                                <td>
                            {{h.Col}}
                        </td>
                                                <td>
                            {{h.Invalid}}
                        </td>
                        <td>
                            {{h.Category}}
                        </td>

            <td>
                <button  @click="Edit(h.ID)"  class="btn btn-primary">Гузариш</button> &nbsp;
                <!-- <button  @click="Spravka(h.ID)"  class="btn btn-info">Чопкунӣ</button> -->
            </td>
        </tr>
        
    </tbody>
</table>
</div>


  <mod v-if="isShowRep" @close="closemod" @scroll="scrollmod" >
  
    <template v-slot:body>
      <member   :id="idrep" ref="repComponent" @close="closemod"></member>
      </template>
  
  </mod>


</template>



<script>
 
 import mod from './ModalForm.vue'
import member from './Members2.vue'

export default {

components:{mod, member},

data(){

    return{
        list:'',
        idrep:0,
        name:'',
        surname:'',
        isShowRep:false


    }
},

 methods:{

async find(){

console.log('start3');
try{
                    await this.$api("/api/find/"+this.name+" /")
                   // .then(res => res.json())
                    .then(data => this.list=data)
                    .catch(error => {
                          console.error("There was an error!", error)
                    });

                    console.log('stop3');
}
catch(ex){
console.log(ex);

}
finally{
console.log('finish');

}

},
find2(){

console.log('start3');

  const requestOptions = {
    method: "Get",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ name: this.name, surname: this.surname })
  };
                    this.$api("/api/find",  requestOptions)
                   // .then(res => res.json())
                    .then(data => this.list=data)
                    .catch(error => {
                          console.error("There was an error!", error)
                    });

                    console.log('stop3');

},
closemod(){
//   this.isShowPrint=false;
  this.isShowRep=false;
},

scrollmod(){
  this.$refs.repComponent.onScroll()
  //  console.log('modal scrolled')

},
async Go(f){

            
 console.log('go to id=',f);


    
                    console.log('start search2');
                    await this.$api("/api/data/2/0/"+f)
                   // .then(res => res.json())
                    .then(data => this.$store.state.household=data)
                    .catch(error => {
                          console.error("There was an error!", error)});
                    
console.log('stop search2', this.$store.state.household.ID);


this.$router.push('/Members')

            

},
    async Edit(id) {
      console.log("edit id=", id);

      await this.$api("/api/data/2/0/" + id)
       // .then((res) => res.json())
        .then((data) => (this.$store.state.household = data))
        .catch((error) => {
          console.error("There was an error!", error);
          return;
        });

 this.idrep=id;

 this.isShowRep=true;

    },
Spravka(h){
console.log(h);
//alert(h);

this.$router.push('./spravka');

}


}



}
</script>
